import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export default function Stoplight(_a) {
    var _b = _a.lowestPercentComplete, lowestPercentComplete = _b === void 0 ? 0 : _b;
    var percent = parseInt(String(lowestPercentComplete), 10);
    var redStyle = classNames({
        'sb-expectations-status-bubble': true,
        red: true,
        active: percent <= 50
    });
    var yellowStyle = classNames({
        'sb-expectations-status-bubble': true,
        yellow: true,
        active: percent > 50 && percent < 100
    });
    var greenStyle = classNames({
        'sb-expectations-status-bubble': true,
        green: true,
        active: percent >= 100
    });
    return (_jsxs("div", { className: "sb-expectations-status-bubbles", children: [_jsx("span", { className: redStyle, children: _jsx("span", { className: "sb-expectations-status-bubble-message", children: "You're lagging behind\u2026" }) }), "\u00A0", _jsx("span", { className: yellowStyle, children: _jsx("span", { className: "sb-expectations-status-bubble-message", children: "Pick up the pace to get ahead!" }) }), "\u00A0", _jsx("span", { className: greenStyle, children: _jsx("span", { className: "sb-expectations-status-bubble-message", children: "Nice job. You're on target." }) })] }));
}
